// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { headerLinkListStyles } from "@bg/Overrides/Widgets/Header/HeaderLinkList";
import { fontConfig } from "@bg/XDL/PreStyle/typography";
import getColor from "@insite/mobius/utilities/getColor";
import { css } from "styled-components";

headerLinkListStyles.link = {
    typographyProps: {
        css: css`
            &&& {
                color: ${getColor("common.white")};
                font-size: ${fontConfig.fontSize.xxSmall}px;
                font-weight: ${fontConfig.weight.semiBold};
                letter-spacing: 1px;
                line-height: ${fontConfig.lineHeight.xSmall};
                text-transform: uppercase;
            }
        `,
    },
    css: css`
        color: ${getColor("common.white")};
    `,
};

headerLinkListStyles.linkWrapper = {
    css: css`
        margin-right: 20px;
        display: flex;
        align-items: center;
        &:after {
            content: "|";
            color: ${getColor("common.white")};
            margin-left: 20px;
        }
        &:last-child {
            padding-right: 0;
            margin-right: 0;

            &:after {
                content: none;
            }
        }
    `,
};
